import React, {useState} from 'react';

export const Level = ({activeClass, level, setLevel, charisma, setCharisma}) => {
    const [showModal, setShowModal] = useState(0);

    const renderButton = (label, change, setter, disabled) => (
        <button
            className={`spaceTop ${disabled ? 'disabled' : ''}`}
            onClick={() => {
                if (disabled) return
                setter(ov => change + parseInt(ov))
            }}
        >
            {label}
        </button>
    )

    const renderModal = () => (
        <div className="levelModalWrapper">
            <div
                className="levelModalBackdrop"
                onClick={() => setShowModal(0)}
            />

            <div className="levelModal">
                <div className="levelModalGroup">
                    Level
                    {renderButton('+', 1, setLevel, level === 20 )}
                    <span className="spaceTop">{level}</span>
                    {renderButton('-', -1, setLevel, level === 1)}
                </div>
                {
                    activeClass === 'bard' && (
                        <>
                            <br/>
                            <div className="levelModalGroup">
                                Charisma
                                {renderButton('+', 1, setCharisma )}
                                <span className="spaceTop">{charisma}</span>
                                {renderButton('-', -1, setCharisma, charisma === 0)}
                            </div>
                        </>
                    )
                }
            </div>
            <div className="spacer"/>
            <div className="spacer"/>
        </div>
    );


    return (
        <>
        <span onClick={() => setShowModal(1)}>lvl {level}</span>
        {showModal ? renderModal() : <></>}
        </>
    );
}